import React from 'react';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';

const ToggleButton = ({ item, onToggle, isAnyLoading }) => {
    const isDisabled = isAnyLoading;
    return (
        <Toggle
            checked={item.isActive}
            onChange={onToggle}
            className={`custom-toggle ${item.isActive ? 'disabled' : ''}`} // Add 'disabled' class if active
            icons={false}
            disabled={isDisabled} 
        />
    );
};

export default ToggleButton;